import styled from 'styled-components'

export const Container = styled.div`
  align-items: center;
  column-gap: 20px;
  display: flex;
  height: 100%;
  justify-content: center;
  position: relative;
  width: 100%;

  #evolutionIcon {
    font-size: ${({iconFontSize}) => iconFontSize ? iconFontSize : "2rem"};
    color: ${({iconColor}) => iconColor ? iconColor : "#000"};
  }
`

export const ValueContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ValueLabel = styled.span`
  font-size: ${({fontSize}) => fontSize ? fontSize : "2rem"};
  font-weight: ${({fontWeight}) => fontWeight ? fontWeight : "500"};
  color: ${({fontColor}) => fontColor ? fontColor : "#000"};
`

export const CustomLabel = styled.span`
font-size: ${({fontSize}) => fontSize ? fontSize : "1rem"};
font-weight: ${({fontWeight}) => fontWeight ? fontWeight : "500"};
color: ${({fontColor}) => fontColor ? fontColor : "#000"};
`

export const ComparisonLabel = styled.span`
  bottom: 0;
  position: absolute;
  right: 0;

  font-size: ${({fontSize}) => fontSize ? fontSize : "1rem"};
  font-weight: ${({fontWeight}) => fontWeight ? fontWeight : "500"};
  color: ${({fontColor}) => fontColor ? fontColor : "#000"};
`